import React from 'react';
import { TableCell, TableRow } from '@applyboard/ui-components';
import { EligibilityStatus } from "../../data";
import ScoreResult from "./ScoreResult";
var CriteriaDetailTableRow = function CriteriaDetailTableRow(_ref) {
  var label = _ref.label,
    criteria = _ref.criteria;
  if (!criteria) return null;
  var noCriteriaData = (criteria === null || criteria === void 0 ? void 0 : criteria.applicantHas) === undefined && (criteria === null || criteria === void 0 ? void 0 : criteria.requirementMet) === undefined && (criteria === null || criteria === void 0 ? void 0 : criteria.requires) === undefined;
  return /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, label), noCriteriaData ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null)) : /*#__PURE__*/React.createElement(ScoreResult, {
    applicantHas: criteria.applicantHas,
    requirementMet: criteria.eligibility === EligibilityStatus.Eligible,
    requires: criteria.requires
  }));
};
export default CriteriaDetailTableRow;